import { jsx as s } from "react/jsx-runtime";
const c = ({ className: o, width: r = "20", height: t = "20" }) => /* @__PURE__ */ s(
  "svg",
  {
    className: o,
    width: r,
    height: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    children: /* @__PURE__ */ s(
      "path",
      {
        d: "M15.333 11c.368 0 .667-.224.667-.5s-.299-.5-.667-.5H4.667c-.369 0-.667.224-.667.5s.298.5.667.5h10.666Z",
        fill: "currentColor"
      }
    )
  }
);
export {
  c as default
};
